<template>
  <div class="grid min-h-screen grid-rows-[1fr_auto]">
    <main ref="mainRef" class="flex min-h-screen parent-wrapper">
      <PageSidebar v-if="user?.isAdmin" />
      <div class="flex-1 min-w-0">
        <TheHeader>
          <template #left>
            <div>
              <ClientOnly>
                <UBreadcrumb :items="breadcrumbs" v-if="user" />
              </ClientOnly>
            </div>
          </template>
        </TheHeader>
        <!-- <TheBreadCrumbHeader v-if="user" /> -->

        <ClientOnly>
          <UContainer
            class="mt-4 flex justify-between items-center"
            v-if="user"
          >
            <UNavigationMenu
              :items="secondaryLinks"
              :ui="{ link: 'group-data-active:before:bg-error' }"
            />
          </UContainer>
        </ClientOnly>

        <main class="pb-[140px]">
          <slot />
        </main>
      </div>
    </main>
    <TheFooter />
  </div>
</template>

<script lang="ts" setup>
import { campaignLabelsSymbol } from "~~/shared/symbols";
import type { NavigationMenuItem } from "@nuxt/ui";

const { user } = useUserSession();

const { data: campaignContent } = await useAsyncData("campaign-content", () =>
  queryCollection("content").path("/campaign").first(),
);

const labels: any = campaignContent.value?.meta;
provide(campaignLabelsSymbol, labels);

const { breadcrumbs } = storeToRefs(useBreadcrumbStore());

const route = useRoute();

const { data: campaign } = useNuxtData(`campaign-${route.params.slug}`);

const secondaryLinks = computed<NavigationMenuItem[]>(() => {
  if (!campaign.value) return [];

  const links: NavigationMenuItem[] = [
    {
      label: "List",
      icon: "lucide:table-properties",
      to: { name: "campaign-slug", params: { slug: campaign.value.slug } },
    },
    ...(canAny(
      "campaign.manage_settings",
      "campaign.manage_users",
      "campaign.manage_security",
    )
      ? [
          {
            label: "Settings",
            icon: "lucide:settings",
            to: {
              name: "campaign-slug-settings",
              params: { slug: campaign.value.slug },
            },
          },
        ]
      : []),
  ];

  if (campaign.value.createSteps) {
    links.splice(1, 0, {
      label: "Steps",
      icon: "lucide:footprints",
      to: {
        name: "campaign-slug-steps",
        params: { slug: campaign.value.slug },
      },
    });
  }

  links.splice(campaign.value.createSteps ? 2 : 1, 0, {
    label: "Assets",
    icon: "lucide:images",
    to: {
      name: "campaign-slug-assets",
      params: { slug: campaign.value.slug },
    },
  });

  if (can("plan_check.view")) {
    links.push({
      label: "Plan Check",
      icon: "lucide:sparkles",
      to: {
        name: "campaign-slug-plan-check",
        params: { slug: campaign.value.slug },
      },
    });
  }

  return links;
});

// dropzone
const mainRef = ref<HTMLDivElement>();
const appConfig = useAppConfig();
const { isOverDropZone: isOverMainDropzone } = useDropZone(mainRef, {
  dataTypes: appConfig.ACCEPTED_FILE_TYPES,
});

provide("isOverMainDropzone", isOverMainDropzone);

const { can, canAny } = usePermissions();
</script>

<style></style>
